import { render, staticRenderFns } from "./uses.vue?vue&type=template&id=4bcb34d2&scoped=true&"
import script from "./uses.vue?vue&type=script&lang=js&"
export * from "./uses.vue?vue&type=script&lang=js&"
import style0 from "./uses.vue?vue&type=style&index=0&id=4bcb34d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bcb34d2",
  null
  
)

export default component.exports